module.exports = __webpack_public_path__ + "media/hideandseek.fc2521be.mp3";